var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.75C1.80937 1.75 1.25 2.30937 1.25 3V11.75H2.5V3H11.25V1.75H2.5ZM5 4.25C4.30938 4.25 3.75 4.80938 3.75 5.5V13C3.75 13.6906 4.30938 14.25 5 14.25H12.5C13.1906 14.25 13.75 13.6906 13.75 13V5.5C13.75 4.80938 13.1906 4.25 12.5 4.25H5ZM5 5.5H12.5V13H5V5.5Z",
    fill: "#687CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3a7c6eed814add92f2ec896e936b0dce.svg";
export { ForwardRef as ReactComponent };